<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('monitoring-point-management')" v-if="permissionCodes.indexOf('044001000') !== -1">
        <i class="el-icon-damai-ic_jiancedianguanli"></i>
        <span slot="title">监测点管理</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('face-detection')" v-if="permissionCodes.indexOf('044002000') !== -1">
        <i class="el-icon-damai-ic_renlianjiance"></i>
        <span slot="title">人脸检测</span>
      </el-menu-item>
      <el-submenu index="3" v-if="permissionCodes.indexOf('044003000') !== -1 || permissionCodes.indexOf('044004000') !== -1 || permissionCodes.indexOf('044005000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_renlianshibie"></i>
          <span>人脸识别</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="3-1" @click="toNewRouter('face-database-management')" v-if="permissionCodes.indexOf('044003000') !== -1">人脸库管理</el-menu-item>
          <el-menu-item index="3-2" @click="toNewRouter('license-logging')" v-if="permissionCodes.indexOf('044004000') !== -1">授权记录</el-menu-item>
          <el-menu-item index="3-3" @click="toNewRouter('identification-logging')" v-if="permissionCodes.indexOf('044005000') !== -1">识别记录</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="4" @click="toNewRouter('image-collections')"  v-if="permissionCodes.indexOf('044006000') !== -1">
        <i class="el-icon-damai-ic_tupianjiansuo"></i>
        <span slot="title">以图搜图</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('face-log')"  v-if="permissionCodes.indexOf('044007000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
     </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: [
    "monitoring-point-management",
    "monitoring-point-management-add",
    "monitoring-point-management-modify"
  ],
  2: "face-detection",
  "3-1": [
    "face-database-management",
    "face-database-authorization",
    "face-database-authorization-black"
  ],
  "3-2": "license-logging",
  "3-3": "identification-logging",
  4: "image-collections",
  5: "face-log"
});

export default {
  name: "customer-flow-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/FaceRecognition/FaceRecognitionNav.vue